<template>
  <v-container fluid class="mx-1" v-if="languageData.sections">
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-card class="operationsCard px-6 py-7" v-if="layout === 'preview'">
      <v-btn :loading="isTimeReportGenerating" @click="generateTimeReportPDF" color="primary">{{ languageData.timeReportForm.downloadPDF }}</v-btn>
      <v-btn @click="showTimeReportPersons" color="primary">{{ languageData.timeReportForm.choosePersonAndSend }}</v-btn>
      <v-btn @click="showTimeReportEmailForm" color="primary">{{ languageData.timeReportForm.typeEmailAndSend }}</v-btn>
    </v-card>
    <v-col cols="12">
      <v-stepper v-model="e1" class="transparent elevation-0">
        <v-card class="mb-5">
          <v-stepper-header class="autoheight">
            <div class="py-5 pl-5 mr-3" v-if="layout !== 'modalCreateTimeReport'">
              <BackButton />
            </div>
            <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>
            <v-stepper-step :complete="e1 > 1" @click="setStep(1)" step="1">{{ languageData.sections.firstHeader }}</v-stepper-step>
            <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

            <v-stepper-step :complete="e1 > 2" @click="setStep(2)" step="2">{{ languageData.sections.second }}</v-stepper-step>
            <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

            <v-stepper-step :complete="e1 > 3" @click="setStep(3)" step="3">{{ languageData.sections.third }}</v-stepper-step>
            <v-divider :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : null"></v-divider>

            <v-stepper-step ref="lastStep" :complete="e1 > 4" @click="setStep(4)" step="4">{{ languageData.sections.vor }}</v-stepper-step>
          </v-stepper-header>
        </v-card>
        <v-card :class="$vuetify.breakpoint.smAndUp ? 'px-10' : null">
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-form ref="formP" v-model="validP">
                      <v-col cols="12" class="warning-block" v-if="renderWarningInfo">
                        <p class="warning-paragraph">{{ layout === 'preview' ? languageData.noHoursInProjectPreview : languageData.noHoursInProject }}</p>
                      </v-col>
                      <p class="text-h5 mb-7">{{ languageData.sections.firstHeader }}</p> 
                      <v-select
                          v-if="layout !== 'modalCreateTimeReport'"
                          :label="languageData.project"
                          :rules="rules.project"
                          v-model="data.project"
                          :items="projects"
                          item-value="id"
                          item-text="name"
                          outlined
                          :disabled="isLayoutPreview"
                          return-object>
                        <template slot='selection' slot-scope='{ item }'>
                          {{ item.name  }}
                        </template>
                        <template slot='item' slot-scope='{ item }'>
                          {{ item.name  }}
                        </template>
                      </v-select>
                      <v-textarea
                          class="pt-1 mb-4"
                          hide-details
                          outlined
                          :rules="rules.description"
                          :label="languageData.labels.description"
                          v-model="data.description"
                          :disabled="isLayoutPreview"
                      ></v-textarea>
                      <v-menu
                          ref="menuStart"
                          v-model="menuStart"
                          :close-on-content-click="false"
                          :return-value.sync="activePickerStart"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="data.date"
                              :rules="rules.date"
                              outlined
                              :label="languageData.labels.date"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="isLayoutPreview"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="data.date"
                            no-title
                            scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              color="primary"
                              @click="menuStart = false"
                          >
                            {{ languageData.cancel }}
                          </v-btn>
                          <v-btn
                              text
                              color="primary"
                              @click="$refs.menuStart.save(data.date)"
                          >
                            {{ languageData.ok }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                </v-row>
                 <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(2)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-card>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-form ref="formR" v-model="validR">
                      <p class="text-h5 mb-7">{{ languageData.sections.second }}</p>
                      <template v-for="(employee, key) in data.employees.length">
                        <div :key="key">
                          <v-row>
                          <p class="px-5 py-5 mb-7 employee-header">{{ languageData.employee }} {{ employee }}</p>
                            <v-btn
                                style="color: white !important;margin-left: 10px !important;"
                                color="error"
                                class="mb-10"
                                v-if="!isLayoutPreview"
                                @click="showDeleteEmployeeModal(key)">
                              {{ languageData.delete_employee }}
                            </v-btn>
                          </v-row>
                          <v-select
                            :label="languageData.employee"
                            :rules="rules['employees.'+key+'.employee']"
                            v-model="data.employees[key].employee"
                            :items="employees"
                            outlined
                            item-value="id"
                            item-text="firstname"
                            :disabled="isLayoutPreview"
                            return-object>
                          <template slot='selection' slot-scope='{ item }'>
                            {{ item.firstname + " " + item.lastname  }}
                          </template>
                          <template slot='item' slot-scope='{ item }'>
                            {{ item.firstname + " " + item.lastname  }}
                          </template>
                        </v-select>
                          <v-row>
                            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
                              <v-menu
                                  ref="timeFrom"
                                  v-model="data.employees[key].menuFrom"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="data.employees[key].timeFrom"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      :rules="rules['employees.'+key+'.timeFrom']"
                                      v-model="data.employees[key].timeFrom"
                                      :label="languageData.labels.time_from"
                                      prepend-inner-icon="mdi-clock-time-four-outline"
                                      readonly
                                      outlined
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="isLayoutPreview"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="data.employees[key].menuFrom"
                                    v-model="data.employees[key].timeFrom"
                                    format="24hr"
                                    outlined
                                    full-width
                                    @click:minute="$refs.timeFrom[key].save(data.employees[key].timeFrom)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xsOnly" cols="1">
                              <v-icon style="line-height: 2.5 !important;">mdi-minus</v-icon>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
                              <v-menu
                                  ref="timeTo"
                                  v-model="data.employees[key].menuTo"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  :return-value.sync="data.employees[key].timeTo"
                                  transition="scale-transition"
                                  offset-y
                                  max-width="290px"
                                  min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                      :disabled="isLayoutPreview"
                                      v-model="data.employees[key].timeTo"
                                      :rules="rules['employees.'+key+'.timeTo']"
                                      :label="languageData.labels.time_to"
                                      prepend-inner-icon="mdi-clock-time-four-outline"
                                      readonly
                                      outlined
                                      v-bind="attrs"
                                      v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="data.employees[key].menuTo"
                                    v-model="data.employees[key].timeTo"
                                    format="24hr"
                                    outlined
                                    full-width
                                    @click:minute="$refs.timeTo[key].save(data.employees[key].timeTo)"
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xsOnly" cols="1">
                              <v-icon style="line-height: 2.5 !important;">mdi-equal</v-icon>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
                                  <v-text-field
                                      :value="diffHours(key)"
                                      :label="languageData.labels.time_diff"
                                      prepend-inner-icon="mdi-clock-time-four-outline"
                                      readonly
                                      outlined
                                      disabled
                                  ></v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                      <div class="w-100 text-left">
                        <v-btn
                          class="button-shadow"
                          color="primary"
                          v-if="!isLayoutPreview"
                          @click="addEmployee">{{ languageData.add_employee }}</v-btn>
                      </div>
                      
                  </v-form>
                  </v-col>
                </v-row>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(1)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(3)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-card>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-form ref="formS" v-model="validS">
                      <p class="text-h5 mb-7">{{ languageData.sections.third }}</p>
                      <v-row>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                          <v-text-field
                              type="number"
                              :rules="rules.transport_kilometers"
                              v-model="data.transport_kilometers"
                              :label="languageData.km_number"
                              outlined
                              @change="getTransportTotalPrice()"
                              :disabled="isLayoutPreview"
                              suffix="km"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1">
                          <v-icon style="line-height: 2.5 !important;">mdi-close</v-icon>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                          <v-text-field
                              type="number"
                              outlined
                              :rules="rules.transport_rate"
                              v-model="data.transport_rate"
                              :label="languageData.km_rate"
                              :disabled="isLayoutPreview"
                              @change="getTransportTotalPrice()"
                              append-icon="euro"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1">
                          <v-icon style="line-height: 2.5 !important;">mdi-equal</v-icon>
                        </v-col>
                        <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                          <v-text-field
                            outlined
                            v-model="data.transport_total"
                            :rules="rules.transport_total"
                            :label="languageData.labels.total_price"
                            disabled></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow mr-4"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(2)">
                    {{ languageData.back }}
                  </v-btn>
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(4)">
                    {{ languageData.next }}
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>
            <v-stepper-content step="4">
              <v-card>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-form ref="formT" v-model="validT">
                      <p class="text-h5 mb-7">{{ languageData.sections.vor }}</p>
                      <template v-for="(cost, key) in data.costs.length">
                        <div :key="key">
                          <v-row>
                            <p class="px-5 py-5 mb-7 employee-header">{{ cost }}</p>
                            <v-btn
                                style="color: white !important;margin-left: 10px !important;"
                                color="error"
                                class="mb-6"
                                v-if="!isLayoutPreview"
                                @click="showDeleteCostModal(key)">
                              {{ languageData.delete_cost }}
                            </v-btn>
                          </v-row>
                          <v-textarea
                              :rules="rules['costs.'+key+'.description']"
                              hide-details
                              outlined
                              class="pt-5 mb-4"
                              :disabled="isLayoutPreview"
                              :label="languageData.labels.description"
                              v-model="data.costs[key].description"
                            ></v-textarea>
                          <v-row>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                              <v-text-field
                                  outlined
                                  :label="languageData.labels.quantity"
                                  :rules="rules['costs.'+key+'.quantity']"
                                  v-model="data.costs[key].quantity"
                                  @change="calculateTotalPrice(key)"
                                  :disabled="isLayoutPreview"
                                  type="number"></v-text-field>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1">
                              <v-icon style="line-height: 2.5 !important;">mdi-close</v-icon>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                              <v-text-field
                                  outlined
                                  :disabled="isLayoutPreview"
                                  :label="languageData.labels.price"
                                  :rules="rules['costs.'+key+'.price']"
                                  v-model="data.costs[key].price"
                                  @change="calculateTotalPrice(key)"
                                  type="number"
                                  append-icon="euro"></v-text-field>
                            </v-col>
                            <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="1">
                              <v-icon style="line-height: 2.5 !important;">mdi-equal</v-icon>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 3 : 12">
                              <v-text-field
                                  outlined
                                  disabled
                                  :label="languageData.labels.price"
                                  :rules="rules['costs.'+key+'.total']"
                                  v-model="data.costs[key].total"
                                  type="number"
                                  append-icon="euro"></v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                      <div class="w-100 text-left">
                        <v-btn
                          class="button-shadow text-left"
                          color="primary"
                          v-if="!isLayoutPreview"
                          @click="addCost">{{ languageData.add_cost }}</v-btn>
                      </div>   
                    </v-form>
                  </v-col>
                </v-row>
                <div class="d-flex justify-end mt-10">
                  <v-btn
                      class="button-shadow"
                      height="55px"
                      color="primary"
                      outlined
                      @click="setStep(3)">
                    {{ languageData.back }}
                  </v-btn>
                </div>
              </v-card>
            </v-stepper-content>
            <div class="d-flex justify-end flex-wrap" style="padding: 0 24px">
              <v-btn
                  class="button-shadow mb-5"
                  color="primary"
                  style="min-width: 30% !important; height: 55px !important"
                  :loading="dataStoreAndSaveIsFetching"
                  v-if="!isLayoutPreview"
                  @click="saveAndSendProjectReport">{{ languageData.btnSaveAndSendTimeReport }}</v-btn>
              <v-btn
                  class="button-shadow mb-5 ml-3"
                  color="primary"
                  height="55px"
                  style="padding-left: 25px !important; padding-right: 25px !important"
                  :loading="dataSaveIsFetching"
                  v-if="!isLayoutPreview"
                  @click="saveProjectReport">{{ languageData.btnSaveText }}</v-btn>
            </div>
          </v-stepper-items>
        </v-card>
      </v-stepper>
    </v-col>
    <ModalInfo
        :typeInfo="typeInfoTimeReportSave || typeInfoTimeReportUpdate"
        :headModal="headInfoTimeReportSave || headInfoTimeReportUpdate"
        :btnAgreeText="languageData.btnAgreeText"
        :visDisAgreeBtn="false"
        @clicked="hideModalTimeReport"
        :show-modal="isTimeReportSave || isTimeReportUpdate"
        :text-modal="textInfoTimeReportSave || textInfoTimeReportUpdate">
    </ModalInfo>

    <ModalInfo 
        @doOperation="deleteModalData" 
        :isLoadingBtn="false" 
        :typeInfo="modalDeleteData.typeInfo" 
        :headModal="modalDeleteData.head" 
        :btnDisAgreeText="languageData.modalDelete.btnDisAgreeText" 
        :btnAgreeText="languageData.modalDelete.btnAgreeText" 
        :visDisAgreeBtn="true" @clicked="hideModalDelete" 
        :show-modal="isShowDeleteModal" 
        :text-modal="modalDeleteData.textInfo">
    </ModalInfo>
  </v-container>
</template>

<script type="text/javascript">
import {mapActions, mapState} from "vuex";
import employeeTypes from "../../../Employees/enums/EmployeeTypeEnum";
import moment from "moment";
import eventBus from "../../../../event-bus/eventBus";
import handleFormError from "../../../../helpers/handleFormError";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import hexColorGenerator from "../../../../helpers/hexColorGenerator";
import downloadFileHelper from "../../../../helpers/downloadFileHelper";
import BackButton from "../../../../components/Global/BackButton";

export default {
  name: "ProjectTimeReportsForm",
  props: {
    layout: String,
    projectData: Object
  },
  components: { BackButton, ModalInfo },
  data() {
    return {
      description: "",
      data: {
        transport_kilometers: 0,
        transport_rate: 0,
        costs: [],
        employees: [],
        transport_total: 0.00
      },
      deleteCostId: [],
      deleteEmployeeId: [],
      employeeTypes: employeeTypes,
      rules: {},
      menuStart: false,
      activePickerStart: null,
      e1: 1,
      validP: false,
      validR: false,
      validS: false,
      validT: false,
      timeFrom: null,
      menu2: false,
      modal2: false,
      menu3: false,
      modal3: false,
      timesFrom: [],
      counter: 0,
      showDiff: false,
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      isShowDeleteModal: false,
      modalDeleteData: {}
    }
  },
  computed: {
    ...mapState("getEmployees", {
      employees: state => state.dataReceive
    }),
    ...mapState("saveProjectReport", {
      dataSaveIsFetching: state => state.dataSaveIsFetching,
      dataStoreAndSaveIsFetching: state => state.dataStoreAndSaveIsFetching,
      textInfoTimeReportSave: state => state.textInfoTimeReportSave,
      typeInfoTimeReportSave: state => state.typeInfoTimeReportSave,
      headInfoTimeReportSave: state => state.headInfoTimeReportSave,
      isTimeReportSave: state => state.isTimeReportSave,
      timeReport: state => state.timeReport,
    }),
    ...mapState("updateTimeReport", {
      isFetchingUpdate: state => state.isFetchingUpdate,
      textInfoTimeReportUpdate: state => state.textInfoTimeReportUpdate,
      typeInfoTimeReportUpdate: state => state.typeInfoTimeReportUpdate,
      headInfoTimeReportUpdate: state => state.headInfoTimeReportUpdate,
      isTimeReportUpdate: state => state.isTimeReportUpdate
    }),
    ...mapState("generateTimeReportPdf", {
      isTimeReportGenerating: state => state.isTimeReportGenerating,
    }),
    ...mapState("getProjects", {
      projects: state => state.dataReceive
    }),
    ...mapState("getTimeReport", {
      dataReceive: state => state.dataReceive
    }),
    isLayoutPreview: function() {
      return this.layout === "preview";
    },
    renderWarningInfo() {
      if (this.layout !== 'modalCreateTimeReport' && this.data.project !== undefined) {
        if (!this.data.project.employee_hour) {    
          return true
        } else {
          return false
        }
      } else if (this.projectData && this.layout === 'modalCreateTimeReport') {
        if (!this.projectData.employee_hour) {
          return true
        } else {
          return false
        }
      }
      return false;
    },
  },
  watch: {
    validP: function() {
      this.isValidP();
    },
    validR: function() {
      this.isValidR();
    },
    validS: function() {
      this.isValidS();
    },
    validT: function() {
      this.isValidT();
    },
  },
  mounted() {
    if(this.layout !== "modalCreateTimeReport") {
      this.updateLanguage(this.getCurrentLanguage);
    }
    this.getEmployees();
    this.getProjects({
          all: true
    });
    if(this.layout === "edit" || this.layout === "preview") {
      this.getTimeReport();
    }
    eventBus.$on("setProjectFormData", () => {
      this.data = this.dataReceive;
    });
    eventBus.$on("saveTimeReportFailure", (errorsData) => {
      this.rules = handleFormError(errorsData);
      this.validP = this.$refs.formP.validate();
      this.validR = this.$refs.formR.validate();
      this.validS = this.$refs.formS.validate();
      this.validT = this.$refs.formT.validate();
      this.isValidP();
      this.isValidR();
      this.isValidS();
      this.isValidT();
    });
    eventBus.$on("generateTimeReportPdfSuccess", (data) => {
      downloadFileHelper(data);
      this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
    })
    eventBus.$on("generateTimeReportPdfFailure", (data) => {
      downloadFileHelper(data);
      this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
    })
    eventBus.$on("saveTimeReportSuccess", () => {
      this.data = {
          transport_kilometers: 0,
          transport_rate: 0,
          costs: [],
          employees: [],
          transport_total: 0.00
      };
      this.data.project = this.projectData;
      this.setStep(1);
      this.updateVisibleCreateTimeReportModal(false);
    })
    if(this.layout === 'modalCreateTimeReport') {
      this.data.project = this.projectData;
    }
    
    eventBus.$on("sendTimeReportFailure", (snackbarData) => {
      this.getSnackBar(snackbarData.title, snackbarData.message, "check_circle", "red");
    });
  },
  methods: {
    ...mapActions("getEmployees", ["getEmployees"]),
    ...mapActions("saveProjectReport", ["storeProjectReport", "storeAndSendProjectReport", "updateVisibleModal", "hideModalSendTimeReport"]),
    ...mapActions("saveProjectEntry", ["storeProjectEntry"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("getTimeReport", ["getTimeReport"]),
    ...mapActions("updateTimeReport", ["updateTimeReport", "updateVisibleModalUpdate"]),
    ...mapActions("generateTimeReportPdf", ["generateTimeReportPdf"]),
    ...mapActions("updateVisibleCreateTimeReportModal", ["updateVisibleCreateTimeReportModal"]),
    ...mapActions("sendTimeReport", ["sendTimeReport", "prepareTimeReport"]),
    ...mapActions("getTimeReportClientPersons", ["getTimeReportClientPersons"]),
    ...mapActions("updateVisibleTimeReportSendEmailModal", ["updateVisibleTimeReportSendEmailModal"]),
    ...mapActions("updateVisibleTimeReportClientPersonsModal", ["updateVisibleTimeReportClientPersonsModal"]),

    saveProjectReport: function() {
      this.data.language = localStorage.getItem("language");
      this.$refs.formP.resetValidation();
      this.$refs.formR.resetValidation();
      this.$refs.formS.resetValidation();

      if(this.layout === "edit") {
        this.data.deleteEmployeeId = this.deleteEmployeeId;
        this.data.deleteCostId = this.deleteCostId;
        this.updateTimeReport({ creds: this.data });
      } else  {
        this.data.hexColor = hexColorGenerator();
        this.storeProjectReport({ creds: this.data });
      }
    },
    saveAndSendProjectReport() {
      this.data.language = localStorage.getItem("language");
      this.$refs.formP.resetValidation();
      this.$refs.formR.resetValidation();
      this.$refs.formS.resetValidation();
      this.data.hexColor = hexColorGenerator();
      this.storeAndSendProjectReport({ creds: this.data });
    },
    storeProjectReportEntry (timeReport) {
      const description = this.languageData.timeReportForm.hourlyReport;
      let projectEntryData = {
        date: timeReport.date,
        description,
        value: timeReport.total,
        projectId: timeReport.project_id
      };
      this.storeProjectEntry( { creds: projectEntryData });
    },
    hideModalTimeReport: function() {
      if(this.layout === "edit") {
        this.updateVisibleModalUpdate(false);
      } else {
        this.updateVisibleModal(false);
      }
    },
    setStep: function(step) {
      this.e1 = step;
      if (this.$refs.lastStep) this.$vuetify.goTo(this.$refs.lastStep);
    },
    addEmployee: function() {
      this.counter = this.counter + 1;
       this.data.employees.push({
         "timeFrom": "",
         "timeTo": "",
         "timeDiff": "",
         "type": this.employeeTypes[0],
         "employee": "",
         "menuTo": false,
         "menuFrom": false,
         "menuDiff": false
       });
    },
    hideModalDelete() {
      this.isShowDeleteModal = false;
    },
    deleteModalData() {
      switch(this.modalDeleteData.type) {
        case 'employee':
          this.deleteEmployee(this.modalDeleteData.key, this.data.employees[this.modalDeleteData.key].id);
          break;
        case 'cost':
          this.deleteCost(this.modalDeleteData.key, this.data.costs[this.modalDeleteData.key].id)
          break;
      }

    },
    showDeleteEmployeeModal(key) {
      var data = {};
      var employee = this.data.employees[key];
      var language = this.languageData.modalDeleteEmployee;
      data.type = 'employee'
      data.id = employee.id;
      data.key = key;
      data.typeInfo = 'info';
      data.head = language.head;
      data.btnDisAgreeText = language.btnDisAgreeText;
      data.btnAgreeText = language.btnAgreeText;
      data.btnAgreeText = 'btnAgreeText';
      data.firstname = employee.employee.firstname ? employee.employee.firstname : '';
      data.lastname = employee.employee.lastname ? employee.employee.lastname : '';
      data.textInfo = language.textInfo + ' ' + data.firstname + ' ' + data.lastname;
      this.modalDeleteData = data;
      this.isShowDeleteModal = true;
    },
    showDeleteCostModal(key) {
      var data = {};
      var cost = this.data.costs[key];
      var language = this.languageData.modalDeleteCost;
      data.type = 'cost'
      data.id = cost.id;
      data.key = key;
      data.typeInfo = language.typeInfo;
      data.head = language.head;
      data.btnDisAgreeText = language.btnDisAgreeText;
      data.btnAgreeText = language.btnAgreeText;
      data.textInfo = language.textInfo;
      this.modalDeleteData = data;
      this.isShowDeleteModal = true;
    },
    isValidP: function() {
      if(this.validP === false) {
        this.setStep(1);
      }
    },
    isValidR: function() {
      if(this.validP !== false && this.validR === false) {
        this.setStep(2);
      }
    },
    isValidS: function() {
      if(this.validP !== false && this.validR !== false && this.validS === false) {
        this.setStep(3);
      }
    },
    isValidT: function() {
      if(this.validP !== false && this.validR !== false && this.validS !== false && this.validT === false) {
        this.setStep(4);
      }
    },
    calculateTotalPrice: function(key) {
      this.data.costs[key].quantity = this.data.costs[key].quantity < 0 ? 0 : parseInt(this.data.costs[key].quantity);
      this.data.costs[key].price = this.data.costs[key].price < 0 ? 0 : parseFloat(this.data.costs[key].price).toFixed(2);
      this.data.costs[key].total = (this.data.costs[key].quantity * this.data.costs[key].price).toFixed(2);
    },
    diffHours: function(key) {
      let timeStart = moment(this.data.employees[key].timeFrom, "hh:mm");
      let timeEnd = moment(this.data.employees[key].timeTo, "hh:mm");
      let diffTimeMinutes = moment.duration(timeStart.diff(timeEnd)).asMinutes();

      if(diffTimeMinutes > 0 || isNaN(diffTimeMinutes)) {
        this.data.employees[key].timeDiff = 0;

        return "";
      } else {
        let diffTimeMinutesCorrect = diffTimeMinutes * -1;
        let hours = parseInt(diffTimeMinutesCorrect/60);
        let minutes = diffTimeMinutesCorrect % 60;
        this.data.employees[key].timeDiff = diffTimeMinutesCorrect;
        if(minutes < 10) {
          return hours + ":0" + minutes;
        } else {
          return hours + ":" + minutes;
        }
      }
    },
    deleteCost: function(key, costId) {
      if(typeof(costId) !== "undefined") {
        this.deleteCostId.push(costId);
      }
      this.data.costs.splice(key, 1);
    },
    deleteEmployee: function(key, employeeId) {
      if(typeof(employeeId) !== "undefined") {
        this.deleteEmployeeId.push(employeeId);
      }
      this.data.employees.splice(key, 1);
    },
    getTransportTotalPrice: function() {
      this.data.transport_kilometers = this.data.transport_kilometers < 0 ? 0.00 : parseFloat(this.data.transport_kilometers).toFixed(2);
      this.data.transport_rate = this.data.transport_rate < 0 ? 0.00 : parseFloat(this.data.transport_rate).toFixed(2);
      this.data.transport_total =  (this.data.transport_kilometers * this.data.transport_rate).toFixed(2)
    },
    addCost: function() {
      this.data.costs.push({
        "description": "",
        "quantity": 0.00,
        "price": 0.00,
        "total": 0.00
      });
    },
    generateTimeReportPDF () {
      this.generateTimeReportPdf();
    },
    showTimeReportPersons() {
      const url = new URL(window.location.href);
      let id = url.searchParams.get("timeReportId");
      if (!id) {
        id = this.timeReport.id
        this.getTimeReportClientPersons({ creds: { id } });
        this.prepareTimeReport(this.timeReport)
      } else {
        this.getTimeReportClientPersons({ creds: { id } });
        this.prepareTimeReport(this.dataReceive)
      }
      this.updateVisibleTimeReportClientPersonsModal(true);
      this.hideModalSendTimeReport(false);
    },
    showTimeReportEmailForm() {
      const url = new URL(window.location.href);
      let id = url.searchParams.get("timeReportId");
      if (!id) {
        this.prepareTimeReport(this.timeReport)
      } else {
        this.prepareTimeReport(this.dataReceive);
      }
      this.updateVisibleTimeReportSendEmailModal(true);
      this.hideModalSendTimeReport(false);
    },
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
  },
  beforeDestroy() {
      eventBus.$off('generateTimeReportPdfSuccess');
      eventBus.$off('sendTimeReportFailure');
      eventBus.$off('saveTimeReportSuccess');
      eventBus.$off('setProjectFormData');
  }
}
</script>